import {ConfigObjectType, loginContainer} from '@wallaby-ui/core';
import * as React from 'react';

interface OwnProps {
  config: ConfigObjectType;
  children: React.ReactNode;
}

type Props = OwnProps;

export const EnsureLoggedInContainerLayoutContainer: React.FC<Props> = (
  props
) => {
  const {config, children} = props;
  return (
    <loginContainer.EnsureLoggedInContainer
      stateId={loginContainer.LOGIN_REDUCER_STATE_ID}
      config={config}
    >
      {children}
    </loginContainer.EnsureLoggedInContainer>
  );
};

EnsureLoggedInContainerLayoutContainer.displayName =
  'EnsureLoggedInContainerLayoutContainer';
